import styled from 'styled-components';
import { Card } from '@material-ui/core';
import ToggleButton from '@material-ui/lab/ToggleButton';
import { TextField } from '@material-ui/core';
export const CardStyle = styled(Card)`
  display: flex;
  height: 40%;
  border: 0px;
`;
export const Entityflex1 = styled(Card)`
  flex: 1;
  padding: 20px 20px;
  height: 70vh !important;
  border: none;
  overflow-y: scroll !important;
`;
export const Entityflex2 = styled(Card)`
  flex: 2;
  padding: 20px 20px;
  flex-grow: 1;
`;
export const Entityflex3 = styled(Card)`
  flex: 2;
  padding: 20px 20px;
`;
export const AccordionButtonStyle = styled(ToggleButton)`
  &.MuiToggleButton-root {
    color: rgba(0, 0, 0, 0.69);
    font-family: 'OpenSans-Regular';
    font-size: 13px;
    letter-spacing: 0;
    text-align: left;
    text-transform: none;
    background-color: #fff;
    border: none;
    display: block;
    width: 100%;
  }
  &.MuiToggleButton-root:focus {
    background-color: #eff3f8 !important;
  }
`;
export const AccordionDisplay = styled.div`
  display: flex;
  flex-direction: column;
`;
export const TypographyStyle = styled.div`
  font-family: 'OpenSans-Regular';
  font-size: 13px;
`;
export const InputTextField = styled(TextField)`
  width: 292px !important;
  box-sizing: border-box !important;
  border: 1px #c9d3dc !important;
  background-color: #ffffff !important;
  border-radius: 2px;

  .MuiOutlinedInput-input {
    padding: 8.5px 14px !important;
  }

  .MuiOutlinedInput-root {
    border-radius: 2px !important;
  }
`;
export default {
  CardStyle,
  Entityflex1,
  Entityflex2,
  AccordionButtonStyle,
  AccordionDisplay,
  TypographyStyle
};